import { makeStyles } from '@material-ui/core';
import colors from 'styles/colors';
import themeStyle from 'styles/theme';

const passwordResetStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(12), // 96px
    maxWidth: theme.spacing(55), // 440px
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(4)
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  },
  icon: {
    color: colors.gray[700],
    marginBottom: theme.spacing(1.5),
    height: theme.spacing(8),
    width: theme.spacing(8),
    border: `1px solid ${colors.gray[200]}`,
    borderRadius: theme.spacing(1.5),
    boxShadow:
      '0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset, 0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      height: theme.spacing(3.5),
      width: theme.spacing(3.5)
    }
  },
  title: {
    fontSize: 30,
    fontWeight: 600,
    width: 'fit-content'
  },
  subtitle: {
    ...themeStyle.typography.mdRegular,
    color: colors.gray[600],
    width: 'fit-content',
    textAlign: 'center'
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  backToLogin: {
    ...themeStyle.typography.smSemibold,
    paddingTop: theme.spacing(1),
    color: colors.gray[600],
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6
  },
  subtitleEmail: {
    fontWeight: 500,
    margin: ` -${theme.spacing(4)}px auto 0`
  }
}));

export default passwordResetStyles;
